import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const TogglePill = ({id, checked = false, ariaLabel}) => {
  if (!id) {
    throw new Error(
      'Inputs need ids that  are the same for attribute as their labels https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox',
    );
  }

  return (
    <div className="TogglePill">
      <input id={id} type="checkbox" className="TogglePill__checkbox" checked={checked} readOnly />
      <label className="TogglePill__handle" htmlFor={id} aria-label={ariaLabel} />
    </div>
  );
};

TogglePill.propTypes = {
  checked: PropTypes.bool,
  ariaLabel: PropTypes.string,
  id: PropTypes.string,
};

export default TogglePill;
